// Tab-local context lets the existing customer configuration screens be reused.
export const ONBOARDING_CUSTOMER_KEY = 'onboardingCustomerId';
export const getOnboardingCustomerId = (): number | undefined => {
  const value = Number(sessionStorage.getItem(ONBOARDING_CUSTOMER_KEY));
  return Number.isInteger(value) && value > 0 ? value : undefined;
};
